<form [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}">
  <div class="ui-g-12 Loyalty">
    <div class="ui-g-12">
      <div class="ui-g-12 ui-md-4">
        <!-- Codice Report -->
        <span class="label">{{'promo.code' | translate}}</span>
        <input type="text" pInputText formControlName="code" maxlength="50"/>
        <span class="input-error-notification" *ngIf="invalidSubmit && form.controls['code'].errors?.required">{{ 'promo.required_error' | translate }}</span>
      </div>
      <div class="ui-g-12 ui-md-8">
        <!-- Descrizione Report -->
        <span class="label">{{'promo.description' | translate}}</span>
        <input type="text" pInputText formControlName="description" maxlength="100"/>
      </div>
    </div>
    <div class="ui-g-12">
    <div class="ui-g-12 ui-md-4">
      <!-- Barcode -->
      <span class="label">{{ 'promo.barcode' | translate }}</span>
      <p-autoComplete
      formControlName="barcode"
      [suggestions]="barcodeOptions"
      (completeMethod)="loadBarcodeResults($event)"
      (onSelect)="onBarcodeSelect($event)"
      [forceSelection]="false"
      [minLength]="4"
      [field]="'ean'" 
      placeholder="{{ 'promo.enter_barcode' | translate }}"
    >
      <ng-template let-item pTemplate="item">
        <!-- Personalizza il template dell'elemento nella lista -->
        <div>
          <strong>{{ item.ean }}</strong> - {{ item.descr }} - 
          <small>{{ getFormattedDate(item.redStartDate) }} - {{ getFormattedDate(item.redEndDate) }}</small>
        </div>
        
        
      </ng-template>
    </p-autoComplete>
      <span class="input-error-notification" *ngIf="invalidSubmit && form.controls['barcode'].errors?.required">
        {{ 'promo.required_error' | translate }}
      </span>
    </div>
    </div>
    
    <div class="ui-g-12">
      <div class="ui-g-12 ui-md-4">
        <span class="label">{{'promo.date_start_redemption' | translate}}</span>
        <!-- Data Inizio Redenzione -->
        <p-calendar 
          formControlName="startDate"
          [dateFormat]="dateFormat" 
         
          [showIcon]="true">
        </p-calendar>
        <span class="input-error-notification" *ngIf="invalidSubmit && form.controls['startDate'].errors?.required">{{ 'promo.required_error' | translate }}</span>
      </div>
      <div class="ui-g-12 ui-md-1"></div>
      <div class="ui-g-12 ui-md-4">
        <span class="label">{{'promo.date_end_redemption' | translate}}</span>
        <!-- Data Fine Redenzione -->
        <p-calendar 
          formControlName="endDate"
          [hourFormat]="24" 
          [dateFormat]="dateFormat" 
         
          [showIcon]="true">
        </p-calendar>
        <span class="input-error-notification" *ngIf="invalidSubmit && form.controls['endDate'].errors?.required">{{ 'promo.required_error' | translate }}</span>
      </div>
      
      <div class="ui-g-12 ui-md-3"></div>
    </div>
  </div>
  <div class="ui-g-12 text-right" style="margin: 20px 0;">
    <button
      type="button"
      pButton
      class="ui-button-success btnSave"
      icon="fa fa-floppy-o"
      (click)="saveReport()"
      label="{{ 'promo.saveSet' | translate }}">
    </button>
    <button
      type="button"
      pButton
      class="ui-button-danger btnCancel"
      icon="fa fa-close"
      (click)="closeModal()"
      label="{{ 'common.cancel' | translate }}">
    </button>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/promotion/report/promo-report-list/promo-report-form/promo-report-form.component.html